
import React, { useEffect, useState } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

const PaymentPage = () => {
  const [signature, setSignature] = useState("");
  const [transactionId, setTransactionId] = useState(uuidv4());

  useEffect(() => {
    const fetchSignature = async () => {
      const res = await axios.post("http://localhost:5000/api/esewa/generate-signature", {
        total_amount: 100,
        transaction_uuid: transactionId,
        product_code: "EPAYTEST",
      });
      setSignature(res.data.signature);
    };

    fetchSignature();
  }, [transactionId]);

  if (!signature) return <div>Loading...</div>;

  return (
    <form
    method="POST"
    action="https://rc-epay.esewa.com.np/api/epay/main/v2/form"
  >
    <input type="hidden" name="amount" value="100" />
    <input type="hidden" name="tax_amount" value="0" />
    <input type="hidden" name="total_amount" value="100" />
    <input type="hidden" name="transaction_uuid" value={transactionId} />
    <input type="hidden" name="product_code" value="EPAYTEST" />
    <input type="hidden" name="product_service_charge" value="0" />
    <input type="hidden" name="product_delivery_charge" value="0" />
    <input type="hidden" name="success_url" value="http://localhost:3000/payment-success" />
    <input type="hidden" name="failure_url" value="http://localhost:3000/payment-failure" />
    <input type="hidden" name="signed_field_names" value="total_amount,transaction_uuid,product_code" />
    <input type="hidden" name="signature" value={signature} />
    <button type="submit">Pay with eSewa (Test)</button>
  </form>
  
  );
};

export default PaymentPage;
